import { ls, t } from '../i18n';
import { useEffect, useRef, useState } from 'react';
import { TRANSITIONS, TRANSITION_LABELS, TRANSITION_MIN_S, TRANSITION_MAX_S,
  transitionWindows, transitionOpacity, type Transition } from '@reels/shared/transitions';
import { Segmented } from './Controls';
import { RangeControl } from './RangeControl';
import previewPhoto from '../assets/preview.webp';

const SAMPLE = [{ src_in: 0, src_out: 1 }, { src_in: 2, src_out: 3 }];
export function TransitionControls({ type, duration, onChange }: {
  type: Transition; duration: number;
  onChange: (patch: { transition?: Transition; transitionDuration?: number }) => void;
}) {
  const [frame, setFrame] = useState(0);
  const [playing, setPlaying] = useState(false);
  const animation = useRef(0);
  useEffect(() => {
    if (!playing) return;
    const started = performance.now();
    const tick = (now: number) => {
      const elapsed = Math.min(2, (now - started) / 1000);
      setFrame(Math.floor(elapsed * 30));
      if (elapsed < 2) animation.current = requestAnimationFrame(tick);
      else setPlaying(false);
    };
    animation.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animation.current);
  }, [playing]);
  const window = transitionWindows(SAMPLE, duration)[0]!;
  const opacity = type === 'off' ? 0 : transitionOpacity(frame / 30, window);
  return <div className="col transition-controls">
    <Segmented ariaLabel={t('editor.transition.aria')} value={type} options={TRANSITIONS.map(value => ({ value, label: value === 'off' ? t('editor.transition.none') : ls(TRANSITION_LABELS[value]) }))}
      onChange={transition => { setPlaying(false); setFrame(0); onChange({ transition }); }} />
    {type !== 'off' && <label className="col transition-duration">
      <span className="row between"><span>{t('editor.transition.duration')}</span><span>{t('editor.transition.seconds', { value: duration.toFixed(2) })}</span></span>
      <RangeControl label={t('editor.transition.durationAria')} min={TRANSITION_MIN_S} max={TRANSITION_MAX_S} step={0.02} value={duration}
        valueText={t('editor.transition.seconds', { value: duration.toFixed(2) })}
        onChange={transitionDuration => { setPlaying(false); setFrame(0); onChange({ transitionDuration }); }} />
    </label>}
    {type !== 'off' ? <>
    <div className="transition-preview" aria-label={t('editor.transition.example')}>
      <img src={previewPhoto} alt="" style={{ transform: frame >= 30 ? 'scale(1.2)' : 'scale(1)' }} />
      <div className="transition-tint" style={{ background: type === 'flash' ? '#fff' : '#000', opacity }} />
      <span className="transition-scene">{frame >= 30 ? t('editor.transition.scene2') : t('editor.transition.scene1')}</span>
      <span className="transition-caption">{t('editor.transition.caption')}</span>
      {!playing ? <button type="button" className="transition-play" aria-label={t('editor.transition.play')}
        onClick={() => { setFrame(0); setPlaying(true); }} /> : null}
    </div>
    <p className="muted small">{t('editor.transition.hint')}</p>
    </> : null}
  </div>;
}
